import http, { base } from '@/config/http'
const namespace = 'products'
const uri = base + '/' + namespace 

const productsLoad = () =>
	http.get(uri)		
const productsCreate = params => 
	http.post(uri, params)
const productsUpdate = params => 
	http.put(`${uri}/${params.id}`, params)
const productsUpdatePositions = params => 
	http.put(`${uri}/positions`, {positions: params})
const productsDelete = page => 
	http.delete(`${uri}/${page.id}`)
const productsFilesLoad = () => 
	http.get(base + '/products/files')	

const productsFilesCreate = productFile =>  
	http.post(base + '/products/files', productFile)
const productsFilesUpdate = productFile =>  
	http.put(`${base}/products/files/${productFile.id}`, productFile)	
const productsFilesDelete = productFile =>  
	http.delete(`${base}/products/files/${productFile.id}`)

const productsBrandsLoad = () => 
	http.get(base + '/products/brands')	
const productsBrandsCreate = brand =>  
	http.post(base + '/products/brands', brand)
const productsBrandsUpdate = brand => 
	http.put(`${uri}/brands/${brand.id}`, brand)
const productsBrandsDelete = brand => 
	http.delete(`${uri}/brands/${brand.id}`)

export default {
	productsLoad,
	productsCreate,
	productsUpdate,
	productsUpdatePositions,
	productsDelete,
	productsFilesLoad,
	productsFilesCreate,
	productsFilesUpdate,
	productsFilesDelete,
	productsBrandsLoad,
	productsBrandsCreate,
	productsBrandsUpdate,
	productsBrandsDelete
}
